import React from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { BuildingTypeInput } from "shared/ui/building-type-input/BuildingTypeInput"

export interface ProductFilterBuildingTypeInputProps extends WithClassName {
  loading?: boolean
  disabled?: boolean
  elevated?: boolean
}

export const ProductFilterBuildingTypeInput = React.memo(
  ({
    loading,
    disabled,
    elevated,
    className
  }: ProductFilterBuildingTypeInputProps) => {
    return (
      <BuildingTypeInput
        loading={loading}
        disabled={disabled}
        elevated={elevated}
        className={classNames("product-filter__building-types", className)}
      />
    )
  }
)

ProductFilterBuildingTypeInput.displayName = "ProductFilterBuildingTypeInput"
